export default "__VITE_ASSET__DYnQfOpD__"